import { computed, unref, type MaybeRef } from 'vue'
import { isCurrentYear } from './is-current-year'

export function useMonthYearString(date: MaybeRef<Date | string | null>) {
  const monthYearString = computed(() => {
    const dateVal = unref(date)
    if (dateVal === null) return ''

    const normalizedDateVal = new Date(dateVal)

    if (isCurrentYear(normalizedDateVal)) {
      return normalizedDateVal.toLocaleDateString('en-US', { month: 'long' })
    }

    return normalizedDateVal.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
  })

  return monthYearString
}
